import { render, staticRenderFns } from "./RegisterCoreBusiness.vue?vue&type=template&id=5514dc2b"
import script from "./RegisterCoreBusiness.vue?vue&type=script&lang=js"
export * from "./RegisterCoreBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/wizard/RegisterCoreBusiness.vue
// module id = 890
// module chunks = 31